<!-- @Author: wuhuiwang -->
<!-- @Date: 2023-6-25 17:33:06 -->
<!-- @Last Modified by: ruiwang -->
<!-- @Last Modified time: 2023-10-11 19:26:48 -->

<template>
    <div class="us">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'AboutUs',

    // title() {
    //     const vm = this;

    //     return vm.$t('ABOUT');
    // }
};
</script>

<style lang="scss" scoped>
.us {
    padding-top: 0.4rem;
    background: linear-gradient(180deg, #f8f8f8 0%, #e3eaf3 100%);
}
</style>
